import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { LogoMark } from "./Brand";
import { scrollTo } from "@/lib/motion";

export default function Footer() {
  const navigate = useNavigate();

  const go = (target) => {
    if (target.startsWith("/")) {
      navigate(target);
      window.scrollTo(0, 0);
      return;
    }
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollTo(target), 350);
      return;
    }
    scrollTo(target);
  };

  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 pb-28 pt-20 lg:pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <button
            data-testid="footer-logo"
            onClick={() => scrollTo(0)}
            className="flex items-center gap-3 transition-opacity hover:opacity-80"
          >
            <LogoMark className="h-9 w-9" />
            <span className="font-display text-base font-bold uppercase tracking-[0.14em]">
              City Girls <span className="text-cherry">Decoded</span>
            </span>
          </button>

          <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
            {[["Episodes", "#episodes"], ["About", "#about"], ["Host", "#hosts"], ["Lowdown", "/lowdown"], ["Dear Glowgetters", "/glowgetters"], ["Rhythm Report", "/rhythm"], ["Contact", "#contact"]].map(([label, target]) => (
              <button
                key={target}
                data-testid={`footer-link-${target.startsWith("/") ? target.split("/")[1] : target.slice(1)}`}
                onClick={() => go(target)}
                className="text-xs font-semibold uppercase tracking-[0.18em] text-white/50 transition-colors hover:text-cherry"
              >
                {label}
              </button>
            ))}
          </nav>

          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollTo(0)}
            aria-label="Back to top"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 text-white transition-all duration-300 hover:border-cherry hover:bg-cherry"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        </div>

        <p className="mt-10 text-[11px] uppercase tracking-[0.2em] text-white/35">
          © {new Date().getFullYear()} City Girls Decoded™. For the Glowgetters —
          all stories decoded, no secrets kept.
        </p>
        <p className="mt-10 text-[10px] uppercase tracking-[0.18em] text-white/30">
          Hero imagery — “Downtown Los Angeles at Night” by Camiloarenivar via Wikimedia Commons, CC BY-SA 4.0
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.9, ease: [0.215, 0.61, 0.355, 1] }}
        className="pointer-events-none mt-12 select-none overflow-hidden px-2 text-center"
        aria-hidden="true"
      >
        <span className="text-outline block whitespace-nowrap font-display text-[11.5vw] font-extrabold uppercase leading-[0.85] tracking-tight">
          City Girls
        </span>
        <span className="block whitespace-nowrap font-display text-[11.5vw] font-extrabold uppercase leading-[0.9] tracking-tight text-cherry/90">
          Decoded
        </span>
      </motion.div>
    </footer>
  );
}
